import {SET_STEP_SUCCESS} from "../constants/stepConstants";

export const setStep = (step) => (dispatch) => {
    dispatch({
        type: SET_STEP_SUCCESS,
        payload: step
    });
};